module.exports = __webpack_public_path__ + "static/media/wunderbaum2.884f6c29.jpg";